// The optional line a guest sees under a step's prompt. One per prompt, so a
// split multi step has two.

import { Input } from "@pej/kore/components";
import type { Control, FieldPath } from "react-hook-form";
import { Field } from "@/lib/forms";
import type { StepsFormValues } from "./survey-schema";

export function StepDescriptionField({
    control,
    name,
    label = "Description",
}: {
    control: Control<StepsFormValues>;
    name: FieldPath<StepsFormValues>;
    label?: string;
}) {
    return (
        <Field
            name={name}
            control={control}
            label={label}
            optional
            render={({ field }) => (
                <Input {...field} value={String(field.value ?? "")} placeholder="Shown under the prompt" />
            )}
        />
    );
}
